/** Keys that never carry a readings send-day. */
const NOTIFY_ONLY_KEYS = new Set([
  'notifier.mail',
  'reporter.mail',
  'telegram_bot_integration',
]);

function keyList(features, facts, name) {
  const value = features?.[name] ?? facts?.[name];
  if (!Array.isArray(value)) {
    return [];
  }
  return value.map((key) => String(key).trim().toLowerCase()).filter(Boolean);
}

/**
 * Why the transmission scale is not drawn.
 * `hasScheduleAnchor` means a send day or instant exists, so the gap is the failure mark.
 */
export function transmissionScaleGapReason(features = {}, facts = {}, { hasScheduleAnchor = false } = {}) {
  if (hasScheduleAnchor) {
    return 'Нет момента сбоя для шкалы';
  }

  const company = keyList(features, facts, 'company_transmission_keys');
  const delivery = keyList(features, facts, 'user_readings_delivery_keys');
  const notify = keyList(features, facts, 'user_notification_keys');
  const unknown = keyList(features, facts, 'unknown_integration_keys');
  const singleKey = String(facts.integration_key || '').trim().toLowerCase();
  const listed = company.length + delivery.length + notify.length + unknown.length > 0 || Boolean(singleKey);
  const active = Boolean(features.has_active_integration || facts.has_active_integration);
  const canHaveDay =
    company.length + unknown.length > 0 || (Boolean(singleKey) && !NOTIFY_ONLY_KEYS.has(singleKey));

  if (!listed && !active) {
    return 'Нет интеграции для передачи показаний';
  }
  if (canHaveDay) {
    return 'День передачи в настройке интеграции не задан';
  }
  if (delivery.length > 0 || notify.length > 0 || NOTIFY_ONLY_KEYS.has(singleKey)) {
    return 'Только уведомления: день передачи не задаётся';
  }
  return 'Нет интеграции для передачи показаний';
}
